import { fetchEventSource } from "@microsoft/fetch-event-source";
import qs from "qs";

export class StreamGpt {
  onStart;
  onCreated;
  onDone;
  onPatch;
  onError;
  onAbort;
  controller;
  constructor(options) {
    const { onStart, onCreated, onDone, onPatch, onError, onAbort } = options;
    this.onStart = onStart;
    this.onCreated = onCreated;
    this.onPatch = onPatch;
    this.onDone = onDone;
    this.onError = onError;
    this.onAbort = onAbort;
    this.controller = new AbortController();
  }
  async stream(data) {
    let count = 0;
    let lastMsg = "";
    let extraParams = {
      api_key: "51job",
      timestamp: parseInt(new Date().getTime() / 1000),
    };
    let _51gptdata = data;
    let _51gptUrl = `https://51gpt.51job.com/external/bcop-activity/assistant/ask?${qs.stringify(
      extraParams
    )}`;

    const _this = this;
    // const controller = new AbortController();
    const signal = _this.controller.signal;

    _this.onStart(data.prompt);
    const eventSource = fetchEventSource(_51gptUrl, {
      method: "POST",
      signal,
      openWhenHidden: true,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(_51gptdata),
      onopen(response) {
        if (!response.ok) {
          return;
        }
      },
      onmessage(event) {
        let res = JSON.parse(event.data);
        if (res.code == "0") {
          const isEnd = res.data.end;
          if (isEnd == 1) {
            _this.onDone(res.data);
          } else {
            count++;
            if (count === 1) {
              _this.onCreated();
            }
            const text = res.data.text;
            if (text !== "") {
              let curMsg = "";
              curMsg = text.slice(lastMsg.length);
              if (curMsg !== "") {
                lastMsg = text;
                _this.onPatch(curMsg);
              }
            }
          }
        } else {
          _this.onError();
        }
      },
      onclose() {
        _this.controller.abort();
        eventSource.close();
      },
      onerror(error) {
        console.log(error);
        _this.controller.abort();
        eventSource.close();
      },
    });
  }
}
